import {useContext, useState} from "react";
import apiRequest from "@services/apiRequest";
import useAsyncError from "@hooks/useAsyncError";
import CountryContext from "../../../../CountryContext";
import AuthenticationService from "@services/AuthenticationService";
import _ from "lodash";
import {generateFilter, splitStringWithLimit} from "./utils";
import {PRIVILEGED_ROLES} from "../../../../constants";

export const useConnectedUsers = () => {

  // context
  const {country: {code}} = useContext(CountryContext);

  // hooks
  const throwError = useAsyncError();

  // state
  const [loading, setLoading] = useState(false);

  // utilities
  const {id, role_type} = AuthenticationService.getUserData();
  const perm = PRIVILEGED_ROLES.includes(role_type) ? role_type : `user_${id}`;

  // handlers
  const fetch = async (search: string, limit: number = 5) => {
    setLoading(true);
    try {
      const splitSearch = splitStringWithLimit(search, " ", 2);
      const payload = {
        country_code: code,
        perm,
        filters: {
          logic: "or",
          filters: [
            generateFilter("email", search),
            ...(
              splitSearch.length < 2
                ? ["firstname", "lastname"].map((column) => generateFilter(column, search))
                : [["firstname", "lastname"], ["lastname", "firstname"]]
                  .map((columns) => ({
                    logic: "and",
                    filters: _.zip(columns, splitSearch)
                      .map(([column, part]) => generateFilter(column!, part!)),
                  }))
            )
          ],
        },
        limit,
        offset: 0,
      };
      const result: any = await apiRequest.post("/connections", payload);
      return result.items;
    }
    catch (e) {
      throwError(e);
      return null;
    }
    finally {
      setLoading(false);
    }
  }

  return {fetch, loading};
}